import { Field } from 'factorial-form'
import type moment from 'moment'

import { observer } from 'mobx-react'

import DayPicker from 'modules/core/components/DayPicker'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { firstDayOfWeekAsIndex } from 'modules/core/lib/firstDayOfWeek'
import i18n from 'modules/core/lib/i18n'

import { maxDate, minDate } from 'modules/shift_management/lib/getMinMaxDates'

export interface Props {
  date: Field
  hideLabel?: boolean
  minDateFromLeave?: moment.Moment
  maxDateFromLeave?: moment.Moment | null
}

const SingleDatePicker = ({
  date,
  hideLabel = false,
  minDateFromLeave,
  maxDateFromLeave,
}: Props) => {
  const {
    access: { firstDayOfWeek },
  } = useCurrentSession()

  const onChangeEvent = (value: string) => {
    date.set(value)
  }

  return (
    <DayPicker
      mode="single"
      label={hideLabel ? '' : `${i18n.t('shift_management.no_selection_form.select_period')}:`}
      onChange={onChangeEvent}
      value={date.value}
      firstDayOfWeek={firstDayOfWeekAsIndex(firstDayOfWeek)}
      focusTrapActive={false}
      valueFormat="backend"
      minDate={minDateFromLeave || minDate}
      maxDate={maxDateFromLeave || maxDate}
    />
  )
}

export default observer(SingleDatePicker)
